import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateNotificationDTO, UpdateNotificationDTO } from "../models/notification/notification.request";
import { GetNotificationInfoDTO, NotificationSettingsListItemDTO } from "../models/notification/notification.response";



export const notificationService = {

    async createNotification(localId: string, dto: CreateNotificationDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/notifications`, dto);
        return data;
    },

    async deleteNotification(localId: string, notificationId: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/notifications/${notificationId}`);
        return data;
    },

    async getNotificationsByLocalId(localId: string): Promise<ApiResponse<NotificationSettingsListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<NotificationSettingsListItemDTO[]>>(`/locals/${localId}/notifications/settings`);
        return data;
    },

    async getNotificationInfo(localId: string, notificationId: string): Promise<ApiResponse<GetNotificationInfoDTO>> {
        const { data } = await api.get<ApiResponse<GetNotificationInfoDTO>>(`/locals/${localId}/notifications/${notificationId}/settings`);
        return data;
    },

    async updateNotification(localId: string, notificationId: string, dto: UpdateNotificationDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/notifications/${notificationId}`, dto);
        return data;
    }

}